import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import Authenticated from './Authenticated'
import UnAuthenticated from './UnAuthenticated'
import { AUTH_TOKEN } from '../constants'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoggedIn: false
    }
  }

  render() {
    const authToken = window.localStorage.getItem(AUTH_TOKEN)
      ? window.localStorage.getItem(AUTH_TOKEN)
      : window.sessionStorage.getItem(AUTH_TOKEN)
    return authToken ? <Authenticated /> : <UnAuthenticated />
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App/index.js